module.exports = __webpack_public_path__ + "assets/img/pz3.1b1165e1.png";